import { Button } from '@mui/material';
import { createColumnHelper } from '@tanstack/react-table';

import Table from '@/components/table/common/Table';
import { IPaginationTable } from '@/components/table/common/interfaces/IPaginationTable';
import { Invite } from '@/interfaces/api/invite/IInvite';

const columnHelper = createColumnHelper<Invite>();

const InvitesTable = ({
	invites,
	pagination,
	onInviteUser,
}: {
	invites: Invite[];
	pagination: IPaginationTable;
	refetch: () => void;
	onInviteUser: () => void;
}) => {
	const columns = [
		columnHelper.accessor('id', {
			header: 'ID',
			cell: (info) => <div>{info.getValue()}</div>,
		}),
		columnHelper.accessor('invitedEmail', {
			header: 'Invited Email',
			cell: (info) => <div>{info.getValue()}</div>,
		}),
		columnHelper.accessor('status', {
			header: 'Status',
			cell: (info) => <div>{info.getValue()}</div>,
		}),
		columnHelper.accessor('invitedDate', {
			header: 'Invited At',
			cell: (info) => <div>{new Date(info.getValue()).toLocaleString()}</div>,
		}),
	];

	return (
		<div className="flex flex-col items-center w-full bg-white p-4 rounded-md shadow-md">
			<div className="flex justify-between w-full mb-4">
				<h3 className="text-lg font-semibold">Invited Users</h3>
				<Button
					variant="contained"
					style={{ backgroundColor: '#00AA55', color: '#fff' }}
					onClick={onInviteUser}
				>
					Invite User
				</Button>
			</div>

			{invites && (
				<Table<Invite>
					collection={{ data: invites, ...pagination }}
					columns={columns}
					paginationSection={pagination}
					dataTest="invites-table"
				/>
			)}
		</div>
	);
};

export default InvitesTable;
